module.exports = __webpack_public_path__ + "img/magic-quill.52260c60.svg";